import React from "react";

export default function NotFound() {
    return (
        <div className="News">
            <div className="AppContainer">
                <h1 className="SectionTitle">PAGE NOT FOUND</h1>
            </div>
        </div>
    );
}
